import { render, staticRenderFns } from "./SessionsBatches.vue?vue&type=template&id=78eda428"
import script from "./SessionsBatches.vue?vue&type=script&lang=js"
export * from "./SessionsBatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports